// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"1":"gift-seller","271":"bugo-account","419":"gift-brand","990":"bugo-auth"}[chunkId] || chunkId) + "." + {"1":"abccc96e","92":"fc22c056","160":"fc22c056","212":"7ac263e6","271":"c200593f","372":"f710f335","419":"eb5e0810","521":"fc22c056","990":"c200593f"}[chunkId] + ".chunk.css";
};